import { render, staticRenderFns } from "./ModernMatterDimensionsTab.vue?vue&type=template&id=bc0fe80a&scoped=true&"
import script from "./ModernMatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ModernMatterDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./ModernMatterDimensionsTab.vue?vue&type=style&index=0&id=bc0fe80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0fe80a",
  null
  
)

export default component.exports